export default "__VITE_ASSET__ic67ak9f__"